<template>
    <div class="bg-white dark:bg-gray-800 shadow-sm p-4 flex justify-between items-center w-full z-50 h-20">
      <div class="flex items-center space-x-4">
        <!-- Sidebar toggle button -->
        <button 
          @click="toggleSidebar"
          class="p-2 rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <h1 class="text-2xl font-bold text-[#035a76] dark:text-gray-200">{{ pageTitle }}</h1>
      </div>
      
      <!-- Right side icons -->
<div :class="[
  'flex items-center space-x-4 flex-shrink-0',
  isSidebarOpen ? 'md:mr-[250px]' : 'md:mr-0'
]">
          <!-- Dark mode toggle -->
        <button 
          @click="toggleDarkMode"
          class="p-2 rounded-full text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          <svg v-if="!isDarkMode" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        </button>
<select
    @change="changeLang($event)"
    class="appearance-none bg-white dark:bg-gray-800 
           border border-gray-200 dark:border-gray-700
           text-gray-700 dark:text-gray-200
           py-2 pl-3 pr-10 rounded-full
           shadow-sm hover:shadow-md
           focus:outline-none focus:ring-2 focus:ring-primary
           transition"
  >
    <option value="en">English</option>
    <option value="fr">Français</option>
  </select>

  <!-- dropdown icon -->
  <div class="absolute inset-y-0 right-3 flex items-center pointer-events-none">
    <svg class="w-4 h-4 text-gray-400 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
    </svg>
  </div>
        
        <!-- Notification icon -->
        <button class="p-2 rounded-full text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 relative">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
          <span class="absolute top-0 right-0 h-2 w-2 rounded-full bg-red-500"></span>
        </button>
        
        <!-- User dropdown -->
        <div class="relative">
          <button 
            @click="toggleUserDropdown"
            class="flex items-center space-x-2 focus:outline-none"
          >
            <div class="h-8 w-8 rounded-full bg-[#035a76] flex items-center justify-center text-white">
              <span>{{ getInitials(user?.name) }}</span>
            </div>
            <span class="text-gray-600 dark:text-gray-300 hidden md:inline">{{ user?.name || "Guest" }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-600 dark:text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          
          <!-- Dropdown menu -->
          <div 
            v-if="isUserDropdownOpen"
            class="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg py-1 z-20"
          >
            <a href="#" class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700">Your Profile</a>
            <a href="#" class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700">Settings</a>
            <a href="#" class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700">Sign out</a>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

function changeLang(event) {
  locale.value = event.target.value
}
  
  const user = ref(null);

onMounted(() => {
  const storedUser = localStorage.getItem("user");
  if (storedUser) {
    user.value = JSON.parse(storedUser);
  }
});
const getInitials = (name) => {
  if (!name) return "";

  const parts = name.trim().split(" ");

  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }

  // First and last name
  return (
    parts[0].charAt(0) +
    parts[parts.length - 1].charAt(0)
  ).toUpperCase();
};
  const props = defineProps({
    pageTitle: {
      type: String,
      default: 'Dashboard Overview'
    },
    isSidebarOpen: {
      type: Boolean,
      default: false
    },
    isDarkMode: {
      type: Boolean,
      default: false
    }
  });
  
  const emit = defineEmits(['toggle-sidebar', 'toggle-dark-mode']);
  
  const isUserDropdownOpen = ref(false);
  
  const toggleSidebar = () => {
    emit('toggle-sidebar');
  };
  
  const toggleDarkMode = () => {
    emit('toggle-dark-mode');
  };
  
  const toggleUserDropdown = () => {
    isUserDropdownOpen.value = !isUserDropdownOpen.value;
  };
  </script>
  
  <style scoped>
  /* Smooth transitions for dark mode */
  .bg-white {
    transition: background-color 0.3s ease;
  }
  .text-gray-800 {
    transition: color 0.3s ease;
  }
  .border-gray-200 {
    transition: border-color 0.3s ease;
  }
  </style>